import {Nullish, useOnMount} from 'shared/web';

import {pushApplicationInitializeEvent} from '../../utils/pushApplicationInitializeEvent';

type ApplicationInitializeEventProps = {
  offerId: string | Nullish;
  workspace: string | Nullish;
};

export function ApplicationInitializeEvent(props: ApplicationInitializeEventProps) {
  useOnMount(() => {
    pushApplicationInitializeEvent({
      workspace: props.workspace,
      environment: process.env.ENV_TYPE,
      offerId: props.offerId,
    });
  });

  return null;
}
